import { useSelector } from 'react-redux';
import { getHomePageByMarket } from '~/constants/markets';
import { StepStatus } from '~/enums';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import { trackCardApplicationActions } from '~/store/actions/analyticsActions';
import { goToPreviousStep } from '~/store/slices/cardApplication.slice';

const useGoToPreviousStep = () => {
  const dispatch = useAppDispatch();
  const { market, language } = useSelector((state: RootState) => state.intl);
  const currentStepNumber = useSelector(
    (state: RootState) => state.cardApplication.currentStepNumber
  );
  const isFirstStep = currentStepNumber === 1;

  const onPreviousStepClick = () => {
    dispatch(
      trackCardApplicationActions({
        actionName: 'back_button_pressed',
      })
    );

    if (isFirstStep) {
      globalThis.location.assign(getHomePageByMarket(market, language));
    } else {
      dispatch(goToPreviousStep());
      dispatch(trackCardApplicationActions({ stepStatus: StepStatus.Edit }));
    }
  };

  return onPreviousStepClick;
};

export default useGoToPreviousStep;
